module.exports = __webpack_public_path__ + "img/pt-single-2.bfae5dc8.jpg";